const districtSettings = (state = {}, action) => {
  switch (action.type) {
    case 'DISTRICT_SETTINGS.POPULATE_DISTRICT_SETTINGS':
      return {
        ...state,
        settings: action.settings,
      };
    case 'DISTRICT_SETTINGS.SET_LOADING_STATE':
      return {
        ...state,
        loading: action.loading,
      };
    case 'DISTRICT_SETTINGS.POPULATE_BLOCKED_CONTENT_EMAIL_LIST':
      return {
        ...state,
        blockedContentEmailList: action.blockedContentEmailList,
      };
    case 'DISTRICT_SETTINGS.POPULATE_STAFF_AUTOCOMPLETE':
      return {
        ...state,
        staffUsers: action.users,
      };
    case 'DISTRICT_SETTINGS.POPULATE_CASELOAD_CATEGORIES':
      return {
        ...state,
        caseloadCategories: action.data,
      };
    case 'DISTRICT_SETTINGS.POPULATE_COLLEGE_COST_SETTINGS':
      return {
        ...state,
        collegeCostSettings: action.data,
      };
    case 'DISTRICT_SETTINGS.POPULATE_COLLEGE_COST_AWARD_TYPES':
      return {
        ...state,
        collegeCostAwardTypes: action.data,
      };
    default:
      return state;
  }
};

export default districtSettings;
